// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"594":"2f7c863dcb86609a06c3","655":"21da88b41b0383af79c1"}[chunkId] + ".js";
};